export const RISK_LEVELS = {
	CRITICAL: 'critical',
	HIGH: 'high',
	MEDIUM: 'medium',
	LOW: 'low'
} as const;

export const RISK_COLORS: Record<string, string> = {
	critical: '#E11900',
	high: '#FF6937',
	medium: '#FFC043',
	low: '#05944F'
};

export const RISK_BADGE_KIND: Record<string, string> = {
	critical: 'negative',
	high: 'warning',
	medium: 'accent',
	low: 'positive'
};

export const ENVIRONMENTS = [
	{ label: 'CSE', id: 'CSE' },
	{ label: 'Production', id: 'Production' }
] as const;

export const BUSINESS_CATEGORIES = [
	'payments',
	'gameplay',
	'user-management',
	'tournaments',
	'rewards',
	'notifications',
	'feature-flags',
	'infrastructure'
] as const;

// URL convention: /dashboard/configImpact/{actionName}
// The last path segment is both the HTTP route and the RBAC action name.
// Backend parses pageName='dashboard', resourceName='configImpact', actionName=<last segment>.
export const CONFIG_IMPACT_ENDPOINTS = {
	GET_CONFIG_KEYS: '/dashboard/configImpact/listKeys',
	GET_CONFIG_KEY_DETAIL: '/dashboard/configImpact/viewDetail',
	GET_CODE_SNIPPETS: '/dashboard/configImpact/codeSnippets',
	ANALYZE_IMPACT: '/dashboard/configImpact/analyzeImpact',
	GET_HISTORY: '/dashboard/configImpact/viewHistory',
	GET_TIMELINE: '/dashboard/configImpact/timeline',
	TRIGGER_REBUILD: '/dashboard/configImpact/triggerRebuild',
	GET_STATS: '/dashboard/configImpact/stats'
};
